import { actions as formActions } from 'react-redux-form'



import { FilterHandler } from './FilterHandler'




class DistanceFilterHandler extends FilterHandler {
  setFormValue = searchFilterFormName => {
    const isSingular = !!this.filter.options

    const { radius, zipCode } = this.filter
    const valuesToSet = {
      radius,
      zipCode
    }


    return formActions.change(`${searchFilterFormName}.${this.filter.id}`, valuesToSet)
  }

  shouldSetParam = value => {
    const toSet = !!value


    return toSet
  }

  updateSearchParams = (value, key, urlSearchParams) => {
    urlSearchParams.set(key, `${value.zipCode},${value.radius}`)
  }
}

export { DistanceFilterHandler }
